import { USER_URL } from "../../../Utils/constService";
import api from "../../../../BasicComponent/Service/api";

export const fetchUserBaged = (params = {}) => {
  return api.get(`${USER_URL}/paged`, { params });
};
export const postUser = (data) => {
  return api.post(USER_URL, data);
};

export const putUser = (data, userId) => {
  return api.put(`${USER_URL}/${userId}`, data);
};

export const deleteUser = (userId) => {
  return api.delete(`${USER_URL}/${userId}`);
};
